// extracted by mini-css-extract-plugin
export default {"item":"Item_item__lRqd9","itemSelecionado":"Item_itemSelecionado__CxEqd","itemCompletado":"Item_itemCompletado__3FSwr","concluido":"Item_concluido__AHcuu"};